import React, {Component} from 'react';
import './Record.css';

import ReactTwig from 'react-twig';
const twig = require('twig');

class Render extends Component {

    constructor() {
        super();

        this.state = {
            hasError: false,
        };

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.template !== this.props.template) {
            this.setState({hasError: false});
        }
    }

    componentDidCatch(error, info) {
        this.setState({hasError: true});
    }

    render() {
        const entry = this.props.entry;
        let render = null;
        try {
            const template = twig.twig({data: this.props.template});
            template.render(entry);

            if (!this.state.hasError) {
                render = <ReactTwig template={this.props.template} data={entry}/>
            } else {
                render = <div>{this.props.template}</div>
            }
        } catch(e) {
            render = <div>{this.props.template}</div>
        }


        return render;
    }


}


export default Render;


// WEBPACK FOOTER //
// ./src/Components/Reunion/Render.js